import sensorsdata from 'sa-sdk-javascript';
import env from '../services/dev';

// doc 地址 https://www.sensorsdata.cn/manual/js_sdk.html
sensorsdata.init({
  server_url: `https://sensorapi.666visa.cn/sa?project=${
    env ? 'default' : 'pdv'
  }`,
  name: 'sensorsdata',
  heatmap_url: '/static/js/heatmap.min.js',
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'default',
  },
  show_log: false,
});

sensorsdata.registerPage({
  platform_type: 'HTML5',
});

sensorsdata.quick('autoTrack');
